import { configureStore } from '@reduxjs/toolkit';

import { userSlice, refreshTokenIntervalSlice, resizeSlice, constantStore, sidebarSlice } from './reducer';

export default configureStore({
    reducer: {
        user: userSlice.reducer,
        refreshTokenInterval: refreshTokenIntervalSlice.reducer,
        constant: constantStore.reducer,
        sidebar: sidebarSlice.reducer,
        resize: resizeSlice.reducer
    }
});
